import React from 'react';
import useShow from '../../../hooks/useShow';
import {TEticketEvent, TEticketOrder, TEticketTicket} from '../../../redux/eTicket/eTicket.type';
import AdditionalInfoSheet from '../components/AdditionalInfoSheet/AdditionalInfoSheet';
import QrZoom from '../components/QrZoom/QrZoom';
import * as css from './TicketDetails.css';
import TicketDetailsBody from './ticketDetailsBody/TicketDetailsBody';
import TicketDetailsHeader from './ticketDetailsHeader/TicketDetailsHeader';
import TicketDetailsStub from './TicketDetailsStub';

interface TicketDetailsProps {
    ticket: TEticketTicket;
    index: number;
    total: number;
    event: TEticketEvent;
    order?: TEticketOrder;
}

function TicketDetails({ticket, index, total, event, order}: TicketDetailsProps) {
    const qrShow = useShow();
    const infoShow = useShow();
    const buyerName = ticket.inviterName ?? [order?.nameFirst, order?.nameLast].filter(Boolean).join(' ');
    const showMoreInfo = !!ticket.additionalInfo && ticket.additionalInfo.trim() !== '';

    return (
        <css.container data-cy="ticket-details">
            <TicketDetailsHeader buyerName={buyerName} order={order} />
            <TicketDetailsBody
                event={event}
                barcode={ticket.barcode}
                qid={ticket.qid}
                index={index}
                total={total}
                onQrZoom={qrShow.open}
            />
            {showMoreInfo && <TicketDetailsStub onMoreInfo={infoShow.open} />}
            {qrShow.isOpen && (
                <QrZoom
                    barcode={ticket.barcode}
                    scanned={ticket.scanned}
                    scanTs={ticket.scanTs}
                    qid={ticket.qid}
                    ticketLabel={`${index + 1}/${total}`}
                    onClose={qrShow.close}
                />
            )}
            {infoShow.isOpen && ticket.additionalInfo && (
                <AdditionalInfoSheet additionalInfo={ticket.additionalInfo} show={infoShow} />
            )}
        </css.container>
    );
}

export default TicketDetails;
